// Link ka jednom receptu (ili tekstu "Kako pomaze", ista sema ruta: kategorija / naslov / id).
// Nov recept ima slug; stari bez sluga - naslov iz teksta (stari nacin).
export function useRecipeLink() {
  const { $srbTolat } = useNuxtApp()

  return (item: Record<string, any>, routeName = 'recept-category-title-id') => ({
    name: routeName,
    params: {
      category: $srbTolat.srbTolatPathSlugify(item.category_name),
      title: item.slug || $srbTolat.srbTolatPathSlugify(item.title),
      id: item.id,
    },
  })
}
